<template>
  <div
    ref="item"
    :key="item.key + 'nested'"
    class="item"
  >
    <div
      class="arrow-container"
      :class="item.line.class"
    >
      <template v-if="nextItemExists">
        <div
          class="upper-tail circle notBlack"
          :style="upperTail"
        />
        <div
          ref="line"
          class="line notBlack"
          :style="line"
        />
        <div
          class="arrow down settled"
          :style="middleTail"
        />
        <div
          ref="line_second"
          class="line accentGreen"
          :style="line2"
        />
        <div
          class="circle down settled"
          :style="bottomTail"
        />
      </template>
    </div>

    <content>
      <div
        v-show="item.value"
        ref="label"
        class="label fixed-text-ellipsis"
      >
        {{ item.value }}
      </div>

      <content-placeholders-text
        v-show="!item.value"
        :lines="1"
        rounded
      />

      <div class="description fixed-text-ellipsis">
        {{ item.label }}
      </div>
      <div class="children-container">
        <div
          v-for="childItem in item.children"
          :key="childItem.key"
          class="children-item"
        >
          <div
            v-show="childItem.value"
            class="label fixed-text-ellipsis"
          >
            {{ childItem.value }}
          </div>

          <content-placeholders-text
            v-show="!childItem.value"
            :lines="1"
            rounded
          />

          <div class="description fixed-text-ellipsis">
            {{ childItem.label }}
          </div>
        </div>
      </div>
    </content>
  </div>
</template>


<script>
const CIRCLE_HEIGHT = 10;
const ARROW_WIDTH = 3;
// const PLAN_ITEM_PADDING = 20;

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      line: {
        top: 0,
        bottom: 0,
        height: 0,
      },

      line2: {
        top: 0,
        bottom: 0,
        height: 0,
      },

      upperTail: {
        top: 0,
      },

      middleTail: {
        top: 0,
      },

      bottomTail: {
        top: 0,
      },

      arrow: {
        bottom: null,
      },

      nextItemExists: false,
    };
  },

  watch: {
    'item.value': {
      immediate: true,
      handler() {
        this.calcArrowHeight();
        this.calculateArrowDimensions();
      },
    },
  },

  mounted() {
    this.calcArrowHeight();
    this.calculateArrowDimensions();
  },

  methods: {
    calcArrowHeight() {
      if (this.item.value) {
        this.$nextTick(async () => {
          const fontHeight = await this.getLabelFontHeight();
          const itemElm = this.$refs.item;
          const nextItemElm = itemElm.nextSibling;
          const itemRect = itemElm.getBoundingClientRect();

          if (nextItemElm) {
            this.nextItemExists = true;
            const nextItemRect = nextItemElm.getBoundingClientRect();

            const lineHeight =
              Math.abs(nextItemRect.top - itemRect.top) -
              fontHeight / 2 +
              ARROW_WIDTH;

            const lineBreakHeight = 3;

            this.middleTail.top =
              lineHeight / 2 + ARROW_WIDTH - lineBreakHeight + 'px';

            this.bottomTail.top =
              lineHeight + lineBreakHeight + fontHeight / 2 + 'px';

            this.line.top = `${fontHeight / 2 + ARROW_WIDTH}px`;
            this.line.height = lineHeight / 2 - lineBreakHeight + 'px';

            this.line2.top = `${
              lineHeight / 2 + fontHeight / 2 + ARROW_WIDTH + lineBreakHeight
            }px`;

            this.line2.height = lineHeight / 2 - lineBreakHeight + 'px';

            this.line2.borderColor = 'green';
          }
        });
      }
    },

    calculateArrowDimensions() {
      if (this.item.value) {
        this.$nextTick(() => {
          const fontHeight = this.$refs.label.clientHeight;
          this.upperTail.top = `${fontHeight / 2 - CIRCLE_HEIGHT / 2}px`;
        });
      }
    },

    getLabelFontHeight() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          const fontHeight = this.$refs.label.clientHeight;
          resolve(fontHeight);
        });
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.item {
  padding: 20px 0;
  display: flex;
  color: $notBlack;

  $arrowContainerWidth: 40px;
  $lineWidth: 2px;
  .arrow-container {
    min-width: $arrowContainerWidth;
    max-width: $arrowContainerWidth;
    position: relative;

    &.notBlack {
      // .line {
      //   background: $notBlack;
      // }
      .arrow {
        border-color: $notBlack;
      }
    }

    &.accentGreen {
      // .line {
      //   background: $accentGreen;
      // }
      .arrow {
        border-color: $accentGreen;
      }
    }

    .upper-tail {
      position: absolute;
      left: 16px;
    }

    .line {
      position: absolute;
      width: $lineWidth;
      // height: 100%;
      left: 50%;
      &.notBlack {
        background: $notBlack;
      }
      &.accentGreen {
        background: $accentGreen;
      }
    }

    $arrowWidth: 3px;
    .arrow {
      border: solid $notBlack;
      border-width: 0 $arrowWidth $arrowWidth 0;
      display: inline-block;
      padding: $arrowWidth;

      &.down {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }

      &.settled {
        position: absolute;
        left: ($arrowContainerWidth/2) - $arrowWidth;
        // bottom: 0;
      }
    }

    // TODO: Need refactoring
    .circle {
      width: 10px;
      height: 10px;
      border: $arrowWidth solid $accentGreen;
      border-radius: 100px;
      &.settled {
        position: absolute;
        left: 16px;
        bottom: -10px;
      }

      &.accentGreen {
        border-color: $accentGreen;
      }

      &.notBlack {
        border-color: $notBlack;
      }
    }
  }

  .fixed-text-ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    // max-width: 100%;

    max-width: 290px;
  }

  content {
    flex: 1;
    .label {
      @include h3;
    }

    .description {
      @include text-tiny;
    }

    .children-container {
      margin-top: 5px;
      .children-item {
        width: 50%;
        display: inline-block;

        .placeholder {
          background-color: $grey10;
          border-radius: 5px;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
